(function () {
  var SCRIPT_URL = 'https://widget.reviews.io/modern-widgets/rating-bar.js';

  function notifyLoaded() {
    document.dispatchEvent(new CustomEvent('trust-bar:reviews-io-loaded'));
  }

  function getUnmountedWidgets(root) {
    return (root || document).querySelectorAll(
      '.reviews-io-rating-bar-widget:not([data-mounted="true"])'
    );
  }

  function resetStructuredWidgets(root) {
    (root || document).querySelectorAll('.reviews-io-rating-bar-widget').forEach(function (el) {
      el.removeAttribute('data-mounted');
      el.innerHTML = '';
    });
  }

  function htmlWidgetIsRendered(widget) {
    if (!widget) return false;
    if (widget.querySelector('iframe')) return true;

    var targets = widget.querySelectorAll('[id^="badge-"]');
    for (var i = 0; i < targets.length; i++) {
      if (targets[i].children.length > 0) return true;
    }

    return false;
  }

  function activateInlineScripts(root, force) {
    (root || document).querySelectorAll('.trust-bar__widget--html').forEach(function (widget) {
      if (widget.dataset.scriptsActivated === 'true') return;

      if (!force && htmlWidgetIsRendered(widget)) {
        widget.dataset.scriptsActivated = 'true';
        return;
      }

      widget.dataset.scriptsActivated = 'true';

      widget.querySelectorAll('script').forEach(function (oldScript) {
        if (oldScript.dataset.trustBarActivated === 'true') return;

        var newScript = document.createElement('script');
        Array.from(oldScript.attributes).forEach(function (attr) {
          newScript.setAttribute(attr.name, attr.value);
        });

        if (oldScript.src) {
          newScript.src = oldScript.src;
        } else {
          newScript.textContent = oldScript.textContent;
        }

        newScript.dataset.trustBarActivated = 'true';
        oldScript.parentNode.replaceChild(newScript, oldScript);
      });
    });
  }

  function loadRatingBarScript(forceReload) {
    var widgets = getUnmountedWidgets();
    if (!widgets.length && !forceReload) return;

    var existing = document.querySelector('script[data-reviews-rating-bar-loader]');

    if (existing && !forceReload && widgets.length) {
      forceReload = true;
    }

    if (existing && !forceReload) return;

    if (existing && forceReload) {
      existing.remove();
    }

    var script = document.createElement('script');
    script.src = SCRIPT_URL + (forceReload ? ('?ts=' + Date.now()) : '');
    script.async = true;
    script.dataset.reviewsRatingBarLoader = 'true';
    script.onload = notifyLoaded;
    document.head.appendChild(script);
  }

  function init(root, force) {
    var scope = root || document;
    var hasCustomHtml = scope.querySelector('.trust-bar__widget--html');

    if (hasCustomHtml) {
      activateInlineScripts(scope, force);
      notifyLoaded();
      return;
    }

    if (!getUnmountedWidgets(scope).length) return;
    loadRatingBarScript(false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document, false);
    });
  } else {
    init(document, false);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    var htmlWidget = section.querySelector('.trust-bar__widget--html');
    var structuredWidget = section.querySelector('.reviews-io-rating-bar-widget');

    if (!htmlWidget && !structuredWidget) return;

    if (htmlWidget) {
      htmlWidget.removeAttribute('data-scripts-activated');
      init(section, true);
      return;
    }

    resetStructuredWidgets(section);
    loadRatingBarScript(true);
  });
})();
